import * as React from 'react';
import { getTranslate } from 'react-localize-redux';
import { useDispatch, useSelector } from 'react-redux';
import { Button, makeStyles, MobileStepper } from '@material-ui/core';

import * as AuthStore from '../../../app/store/AuthStore';
import * as PageSettingStore from '../../../app/store/PageSettingStore';

import { VimoModal, VimoTaskContent } from '../../../common/components';
import { NextIcon, PrevIcon } from '../../../common/icons';
import { preloadImagesInModule } from '../../../youwell-common/taskContentUtils';

const useStyles = makeStyles(theme => ({
    modalContainer: {
        width: 700,
        // height: 700,

        '@media screen and (max-height: 700px)': {
            width: 'auto',
            // height: 'auto',
        },

        [theme.breakpoints.down('sm')]: {
            width: `calc(100% - ${theme.spacing(4)}px)`,
        },

        [theme.breakpoints.down('xs')]: {
            // height: 'auto',
        },

    },
    modalContent: {
        padding: '0 2px',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '60vh',
    },
    task: {
        flex: '1 1 auto',
        overflowY: 'auto',
    },
    navigation: {
        padding: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-between',
        background: theme.colors.grey1,
    },
    navigationProgress: {
        background: theme.colors.grey1,
    },
    navigationDot: {
        width: theme.spacing(4),
        height: theme.spacing(4),
    },
    navSpacer: {
        width: 64,
    },
    taskElementRoot: {
        marginBottom: 0,
        background: theme.colors.grey2,
    },
    taskElementContent: {
        marginBottom: 0,

        '&.htmlcontent figure.image img': {
            maxHeight: '48vh',
        },
    },
}));

const VimoIntroTour = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const translate = useSelector(state => getTranslate(state.localize));
    const profileData = useSelector(state => state.auth.profileData);
    const showIntroTourFromState = useSelector(state => state.pageSettings.showIntroTour);
    const introModule = useSelector(state => state.program.content
        && state.program.content[state.pageSettings.appConfig?.contentProgramId]?.modules
        ?.find(d => d.id === state.pageSettings.appConfig?.introTourModuleId));

    const [showIntro, setShowIntro] = React.useState(false);
    const [page, setPage] = React.useState(0);

    React.useEffect(() => {
        setShowIntro(profileData?.userSettings?.showIntroTour || showIntroTourFromState);
    }, [profileData?.userSettings?.showIntroTour, showIntroTourFromState]);

    React.useEffect(() => {
        if (showIntro && introModule) {
            preloadImagesInModule(introModule);
        }
    }, [introModule, showIntro]);

    if (!introModule) {
        return null;
    }

    const navigate = step => () => {
        setPage(prev => prev + step);
    };

    const close = () => {
        setShowIntro(false);
        dispatch(PageSettingStore.actionCreators.showIntroTour(false));

        if (profileData?.userSettings?.showIntroTour) {
            dispatch(AuthStore.actionCreators.setConfig({ key: 'showIntroTour', value: false }));
        }
    };

    const tasks = introModule?.tasks || [];

    return (
        <VimoModal
            open={showIntro}
            onClose={close}
            heading={translate('introTour.heading')}
            classes={{ modalContainer: classes.modalContainer, modalContent: classes.modalContent }}
        >
            <div className={classes.content}>
                <VimoTaskContent
                    className={classes.task}
                    task={tasks[page]}
                    classes={{ elementRoot: classes.taskElementRoot, elementContent: classes.taskElementContent }}
                />

                <div className={classes.navigation}>
                    {page > 0 ? (
                        <Button onClick={navigate(-1)} variant="contained" color="primary">
                            <PrevIcon />
                        </Button>
                    ) : (<div className={classes.navSpacer} />)}

                    <MobileStepper
                        variant="dots"
                        steps={tasks.length}
                        position="static"
                        activeStep={page}
                        className={classes.navigationProgress}
                        classes={{ dot: classes.navigationDot }}
                    />

                    {page < tasks.length - 1 ? (
                        <Button onClick={navigate(1)} variant="contained" color="primary">
                            <NextIcon />
                        </Button>
                    ) : (<div className={classes.navSpacer} />)}
                </div>
            </div>
        </VimoModal>
    );
};

export default VimoIntroTour;
